import CreateVoucher from "@/components/Vouchers/CreateVoucher";

const CreateVoucherPage = () => <CreateVoucher />;

export default CreateVoucherPage;
